<template>
  <div>
    <!-- 按内容 -->
    <div class="top-info top-info1">
      <div class="info-card">
        <div class="img-box">
          <img v-if="visitTypeImg" class="product-img" :src="visitTypeImg" alt="" />
          <img v-else class="icon" :src="typeImg[visitType]" alt="" />
        </div>
        <div class="tip">{{ VISIT_TYPE[visitType] }}</div>
      </div>
      <div class="info">
        <div class="name-info txt-ellipsis2">
          <span v-if="visitType == 7">我的电子名片</span>
          <span v-else-if="visitType == 8">我的个人微店</span>
          <span v-else-if="visitType == 9">我的预约顾问</span>
          <span v-else>{{ contentTitle }}</span>
        </div>
        <div class="count">
          共<span class="ok-txtcolor">{{ count }}</span
          >人来访
        </div>
      </div>
    </div>
    <div class="list-box">
      <div class="status-title">访问动态</div>
      <van-list v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了" @load="nextPage">
        <div class="list-item" v-for="(item, idx) in list" :key="item.id">
          <div class="item-box item-box1">
            <img class="img" @click="toDetail(item)" :src="item.imgUrl" alt="" />
            <div class="item-info" @click="toDetail(item)">
              <div class="item-title item-title1">
                {{ item.nickname }}
                <span v-if="item.customerName">（客户：{{ item.customerName }}）</span>
              </div>
            </div>
            <div class="change-customer ok-bgcolor" v-if="!item.customerName" @click="changeCustomer(item.visitorId)">转为客户</div>
          </div>
          <div class="time">
            <span>最近阅读时间：{{ item.time }}</span>
            <span v-if="item.visitTimeInfo" class="read-time">阅读{{ item.visitTimeInfo }}</span>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { loading, common } from '@/api/mixins';
export default {
  props: {},
  components: {},
  mixins: [loading, common],
  data() {
    return {
      typeId: '',
      list: [],
      imgUrl: '',
      visitorId: '', //访问id
      nickName: '',
      sex: '',
      customerName: '', //客户姓名
      visitType: '', //访问类型
      visitTypeImg: '', //访问类型图标
      count: '', //访问人数
      contentTitle: '',
      pageNo: 1,
      VISIT_TYPE: {},
      typeImg: {
        2: require('@static/images/business/icon_planbook.png'), //计划书
        // 4: require("@static/images/business/icon_text.png"), //托管报告
        7: require('@static/images/business/icon_card.png'), //名片
        8: require('@static/images/business/icon_wd.png'), //微店
        9: require('@static/images/business/icon_yygw.png') //预约顾问
      },
      type: ''
    };
  },
  computed: {},
  watch: {},
  created() {
    this.init();
    //查字典
    this.getDicByType({
      type: 'VISIT_TYPE'
    }).then(res => {
      this.VISIT_TYPE = res;
    });
  },
  mounted() {},
  methods: {
    init() {
      this.typeId = this.$route.query.typeId;
      this.type = this.$route.query.type;
      this.pageNo = 1;
      this.getList(false);
    },
    //上拉加{载
    nextPage() {
      if (this.list.length == this.count) {
        this.finished = true;
        return;
      }
      this.pageNo++;
      this.getList(false);
    },
    //查询详情
    getList(loading = true) {
      this.loading = true;
      this.$http({
        type: 'POST',
        url: '/app/visitRecord/list',
        data: {
          pageNo: this.pageNo,
          pageSize: 10,
          tabType: 2,
          typeId: this.typeId,
          type: this.type
        },
        apiPermissionCode: 'APP_VISITOR_DETAIL'
      })
        .then(res => {
          this.loading = false;
          this.pageNo = res.current;
          this.count = res.total;
          if (res.current == 1) {
            this.list = [];
          }
          res.data = res.data.map(item => {
            if (item.createTime) {
              if (dayjs().year() == dayjs(item.createTime).year()) {
                item.time = dayjs(item.createTime).format('MM-DD HH:mm');
              } else {
                item.time = dayjs(item.createTime).format('YYYY-MM-DD HH:mm');
              }
            }
            if (item.visitTime) {
              item.visitTimeInfo = this.$tools.formatSeconds(item.visitTime);
            }
            return item;
          });
          this.list = this.list.concat(res.data);
          if (res.current === res.pages) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          this.getCustomerInfo(this.list[0]);
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },
    //客户信息
    getCustomerInfo(info) {
      this.sex = info.sex;
      this.nickName = info.nickname;
      this.customerName = info.customerName;
      this.imgUrl = info.imgUrl;
      this.visitType = info.type;
      this.visitTypeImg = info.typeImg;
      this.contentTitle = info.name;
    },
    //链接跳转
    toUrl(url) {
      location.href = url;
    },
    toDetail(info) {
      //访客详情-访客视图
      this.$router.push({
        path: '/apps/business/visitorDetail',
        query: {
          visitorId: info.visitorId,
          type: this.type //访问类型
        }
      });
    },
    changeCustomer(id) {
      this.$router.push({
        name: 'apps.business.addCustomer',
        query: {
          visitorId: id
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.top-info {
  display: flex;
  align-items: center;
  padding: 30px 30px 70px;
  background-image: url('~static/images/visitorDetail/bg.png');

  > img {
    width: 110px;
    height: 110px;
    border-radius: 50%;
  }

  .name,
  .wx-name {
    color: #17233d;
    margin: 0 0 0 20px;
    font-size: 38px;
    font-weight: bold;

    img {
      width: 24px;
      height: 24px;
    }
  }

  .name {
    font-size: 26px;
    font-weight: normal;
    margin-top: 17px;
  }

  .wx {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 172px;
    height: 50px;
    border: 1px solid #4cbf02;
    border-radius: 35px;
    padding: 0 20px;
    margin-left: 30px;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .wx1 {
    align-self: flex-start;
  }
  .info-card {
    flex: 0 0 150px;
    height: 150px;
    border-radius: 10px;
    background-color: #fff;
    margin-right: 20px;
    overflow: hidden;

    .img-box {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 108px;

      .icon {
        width: 50px;
        height: 50px;
      }

      .product-img {
        width: 100%;
        height: 100%;
      }
    }

    .tip {
      height: 42px;
      line-height: 42px;
      background: #e7effd;
      font-size: 24px;
      color: #2e4f96;
      text-align: center;
    }
  }

  .info {
    .name-info {
      height: 82px;
      color: #17233d;
      font-size: 30px;
    }

    .count {
      margin-top: 30px;
      font-size: 26px;
      color: #727c8e;

      span {
        color: #236dff;
      }
    }
  }
}

.top-info1 {
  align-items: flex-start;
}

.steps-box,
.list-box {
  position: relative;
  z-index: 2;
  border-radius: 30px 30px 0px 0px;
  padding: 0 10px;
  overflow: hidden;
  margin-top: -30px;
  padding-bottom: 120px;
  background-color: #fff;

  .status-title {
    font-size: 34px;
    font-weight: bold;
    padding: 30px 0 15px 30px;
  }

  .item-box {
    display: flex;
    margin-top: 20px;

    .img {
      width: 86px;
      height: 86px;
      border-radius: 50%;
      margin-right: 20px;
    }

    .item-card {
      flex: 0 0 130px;
      height: 130px;
      border-radius: 10px;
      background: rgba(244, 246, 250, 0.39);
      margin-right: 20px;

      .img-box {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 88px;

        .icon {
          width: 50px;
          height: 50px;
        }

        .product-img {
          width: 100%;
          height: 100%;
        }
      }

      .tip {
        height: 42px;
        line-height: 42px;
        background: rgba(231, 239, 253, 0.39);
        font-size: 24px;
        color: #2e4f96;
        text-align: center;
      }
    }
    .item-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .item-title {
      font-size: 30px;
      color: #17233d;
      height: 82px;
    }

    .item-title1 {
      min-width: 400px;
      height: auto;
    }

    .read-time {
      font-size: 26px;
      color: #727c8e;
      margin-top: 11px;
    }

    .change-customer {
      margin-left: auto;
      align-self: center;
      width: 136px;
      height: 50px;
      background: rgb(35, 109, 255);
      border-radius: 8px;
      color: #fff;
      font-size: 24px;
      line-height: 50px;
      text-align: center;
    }
  }

  /deep/ .van-step__circle {
    width: 20px;
    height: 20px;
  }

  /deep/ .van-step__icon--active {
    font-size: 32px;
  }

  /deep/ .van-step__title--active {
    .time {
      color: #236dff;
      font-size: 28px;
      font-weight: bold;
    }
  }
}
.list-box {
  padding: 0 30px;
  .status-title {
    padding-left: 0;
  }
  .time {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    font-size: 26px;
    color: #727c8e;
  }
  .list-item {
    padding-bottom: 30px;
    border-bottom: 1px solid #ececec;
  }
}
.btns {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 120px;
  border-top: 1px solid #ececec;
  padding: 0 30px;
  z-index: 99;
  background-color: #fff;

  div {
    width: 335px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    font-size: 32px;
    border: 1px solid #236dff;
    border-radius: 10px;
    color: #236dff;
  }

  .btn-right {
    background-color: #236dff;
    color: #fff;
  }
}
</style>
